// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9c154ef2fb92a76bdcc3","655":"fd2e0a931678209db62e"}[chunkId] + ".js";
};